import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69d1713034b9ae001473d385/vocedlms/src/app/sign-up-login-screen/components/AuthContainer.tsx");
